/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import ConsentingJournalContainer from '../../components/consentingJournal/consenting.journal.container';

class ConsentingJournalPage extends React.Component {
  render() {
    return <ConsentingJournalContainer />;
  }
}

export default ConsentingJournalPage;
